import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const ResourcesPageContent = lazy(() => import("./ResourcesPageContent"));

function ResourcesPageInternal() {
    return (
        <DefaultPage>
            <ResourcesPageContent />
        </DefaultPage>
    );
}

export const ResourcesPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(ResourcesPageInternal);
